<template>
  <ActListBox
    listType="row"
    :api="postHotfts"
    :params="params"
    type="9"
    :title="$t('new.text56') + ' NFT'" />
</template>
<script>
import { postHotfts } from '@/api/user'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'UserEventList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postHotfts,
      params: { category_id: 2 }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'UserNftDetail') {
      this.$store.commit('SET_KEEP_ALIVE', [])
    }
    next()
  },
  created() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/user/eventlist.vue